export const environment = {
  production: true,
  flattenPdfApiUrl: '/api/flatten-pdf' as string | undefined,
  contactApiUrl: '/api/contact' as string | undefined
};
